export default __webpack_public_path__ + "static/media/University_Blue.7fb994d3.jpeg";